export default {
    api_url : 'https://g2.victory-partners.ma',
}